<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.315"
    height="23.237"
    viewBox="0 0 25.315 23.237"
  >
    <g
      id="Сгруппировать_4631"
      data-name="Сгруппировать 4631"
      transform="translate(477.553 -1407.814)"
    >
      <path
        id="Контур_3622"
        data-name="Контур 3622"
        d="M-450.922,1410.1c-1.618-1.943-5.809-2.97-8.359-.835a6.024,6.024,0,0,0-.743,8.478l.116.139h0a5.979,5.979,0,0,0,8.456.612C-448.167,1415.606-449.783,1411.465-450.922,1410.1Zm-1.829,7.209a4.332,4.332,0,0,1-5.863-.513l-.116-.139a4.128,4.128,0,0,1-.35-.513c-.058-.093-.123-.184-.173-.279a4.343,4.343,0,0,1-.207-.491c-.037-.1-.081-.2-.11-.3a4.334,4.334,0,0,1-.106-.513c-.017-.1-.039-.206-.049-.309a4.47,4.47,0,0,1,0-.509c0-.108,0-.217.011-.325a4.4,4.4,0,0,1,.088-.479c.025-.114.044-.227.078-.339a4.281,4.281,0,0,1,.172-.437c.048-.113.092-.228.15-.338.073-.135.163-.261.249-.388.074-.108.143-.218.226-.32a4.18,4.18,0,0,1,.318-.328c.1-.1.2-.2.31-.293s.232-.161.35-.238a4.483,4.483,0,0,1,.392-.243c.116-.059.238-.1.357-.15a4.4,4.4,0,0,1,.438-.162c.118-.033.238-.05.358-.073a4.154,4.154,0,0,1,.469-.074c.114-.01.228,0,.342,0a4.338,4.338,0,0,1,.492.018c.106.012.21.038.316.058a4.244,4.244,0,0,1,.5.115c.1.031.193.075.289.114a4.35,4.35,0,0,1,.481.214c.092.05.176.114.265.17a4.266,4.266,0,0,1,.436.308c.083.07.157.153.236.23a4.2,4.2,0,0,1,.425.452A4.331,4.331,0,0,1-452.752,1417.3Z"
        transform="translate(-2.986)"
        fill="#ffbf00"
        stroke="#db7b0e"
        stroke-miterlimit="10"
        stroke-width="0.5"
      />
      <path
        id="Контур_3623"
        data-name="Контур 3623"
        d="M-454.473,1416.885a5.229,5.229,0,0,0-1.121-1.886,4.821,4.821,0,0,0-.372-.448,4.784,4.784,0,0,0-1.4-1.028,4.425,4.425,0,0,0-4.727.608l-.472.4,0,0h0c-.008.006-.011.015-.019.023a.842.842,0,0,0-.188.235.84.84,0,0,0,.1.928l2.57,3.062,0,0,2.569,3.061h0a.842.842,0,0,0,1.186.1l.472-.4c.086-.073.169-.147.25-.226A4.449,4.449,0,0,0-454.473,1416.885Z"
        transform="translate(-2.707 -0.976)"
        fill="#0088a9"
        stroke="#0b5b79"
        stroke-miterlimit="10"
        stroke-width="1"
      />
      <path
        id="Контур_3624"
        data-name="Контур 3624"
        d="M-462.826,1422.548l-1.253-1.494h0l-1.252-1.492a.8.8,0,0,0-1.129-.034l-1.43,1.2a5.077,5.077,0,0,1-.447.316c-.085.056-.162.124-.249.176a5.1,5.1,0,0,1-.5.242c-.088.039-.171.092-.262.126a5.137,5.137,0,0,1-.656.193c-.052.013-.1.035-.155.046a5.189,5.189,0,0,1-.845.1,6.125,6.125,0,0,0-5.74,5.155,4.637,4.637,0,0,0-.051.613c0,.036-.01.071-.01.107,0,.086.006.17.01.255l0,.04a4.614,4.614,0,0,0,1.031,2.677c.013.015.023.033.036.049l0,0a4.62,4.62,0,0,0,3.508,1.661,6.136,6.136,0,0,0,6.074-4.766,5.141,5.141,0,0,1,1.713-2.847l1.437-1.205A.806.806,0,0,0-462.826,1422.548Z"
        transform="translate(0 -2.183)"
        fill="#ffbf00"
        stroke="#db7b0e"
        stroke-miterlimit="10"
        stroke-width="1.5"
      />
      <path
        id="Контур_3628"
        data-name="Контур 3628"
        d="M-468.649,1410.861a2.529,2.529,0,0,1,3.561.312l10,11.918a2.528,2.528,0,0,1-.375,3.555,2.527,2.527,0,0,1-3.5-.305l-10-11.919a2.529,2.529,0,0,1,.312-3.561Z"
        transform="translate(-1.408 -0.427)"
        fill="#40b8de"
        stroke="#0b5b79"
        stroke-miterlimit="10"
        stroke-width="1"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconChild',
  }
</script>
